import React, { useState } from 'react';
import { Box, Container, Typography, Divider, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';

export default function FAQ() {
    const [expandedItems, setExpandedItems] = useState({});
    const { t } = useTranslation();
    const toggleExpanded = (id) => {
        setExpandedItems(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const faqData = [
        {
            id: 'panel1',
            question: t('FAQ01'),
            answer: t('FAQ08')
        },
        {
            id: 'panel2',
            question: t('FAQ02'),
            answer: t('FAQ09')
        },
        {
            id: 'panel3',
            question: t('FAQ03'),
            answer: t('FAQ10')
        },
        // {
        //     id: 'panel4',
        //     question: t('FAQ04'),
        //     answer: t('FAQ11')
        // },
        {
            id: 'panel5',
            question: t('FAQ05'),
            answer: t('FAQ12')
        },
        {
            id: 'panel6',
            question: t('FAQ06'),
            answer: t('FAQ13')
        },
        {
            id: 'panel7',
            question: t('FAQ07'),
            answer: t('FAQ14')
        }
    ];

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 6, md: 8 },
                px: { xs: 2, md: 4 },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Container maxWidth="md">

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        textAlign: 'left',
                        gap: 2,
                        mb: 4,
                    }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.4rem' },
                            fontWeight: 700,
                            lineHeight: 1.2,
                            color: '#1a202c',
                        }}
                    >
                        {t('FAQ15')}
                    </Typography>

                </Box>

                <Box sx={{ maxWidth: 800, mx: 0, textAlign: 'left' }}>
                    {faqData.map((faq, index) => (
                        <Box key={faq.id}>
                            <Box
                                sx={{
                                    py: 2,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                    }
                                }}
                                onClick={() => toggleExpanded(faq.id)}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography
                                        sx={{
                                            fontFamily: 'Barlow, sans-serif',
                                            fontSize: '1.1rem',
                                            fontWeight: 600,
                                            color: '#1a202c',
                                            lineHeight: 1.3,
                                            flex: 1,
                                            pr: 2,
                                        }}
                                    >
                                        {faq.question}
                                    </Typography>
                                    <IconButton
                                        sx={{
                                            color: '#1a202c',
                                            transition: 'transform 0.2s ease',
                                            transform: expandedItems[faq.id] ? 'rotate(180deg)' : 'rotate(0deg)',
                                        }}
                                    >
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </Box>

                                {expandedItems[faq.id] && (
                                    <Typography
                                        sx={{
                                            fontFamily: 'Barlow, sans-serif',
                                            fontSize: '0.95rem',
                                            color: 'text.secondary',
                                            lineHeight: 1.5,
                                            mt: 1.5,
                                            pt: 1.5,
                                            borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                                        }}
                                    >
                                        {faq.answer}
                                    </Typography>
                                )}
                            </Box>
                            {index < faqData.length - 1 && (
                                <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.1)' }} />
                            )}
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
}
